<template>
  <div class="yingxiang">
    <!-- 分享所带图片 -->
    <img
      style="width: 0px; height: 0px; position: absolute; z-index: -1"
      src="../../assets/images/dongguologo.jpg"
    />
    <div class="Oulist" v-for="(item, index) in arrLIst" :key="index">
      <div
        class="information edit"
        v-html="item.HtmlBody ? item.HtmlBody : ''"
      ></div>
    </div>
    <!-- 表单 -->
    <div class="biaodan">
      <span>立即咨询</span>
      <p>请您保持手机畅通 联络处老师会尽快联系您</p>
      <div class="biaodanbox">
        <el-form :model="formLabelAlign" label-width="0px">
          <el-form-item>
            <p><span class="icon">*</span>您的姓名</p>
            <el-input
              v-model.trim="formLabelAlign.name"
              placeholder="请输入姓名"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <p><span class="icon">*</span>联系方式</p>
            <el-input
              v-model="formLabelAlign.phone"
              placeholder="请输入手机号码"
            ></el-input>
          </el-form-item>
          <el-form-item class="margbottom0">
            <p><span class="icon">*</span>当前学历</p>
            <el-select
              v-model="formLabelAlign.xueli"
              placeholder="请输入当前学历"
              :popper-append-to-body="false"
            >
              <el-option
                v-for="item in formxueliList"
                :key="item.S99_CodeId"
                :label="item.S99_Name"
                :value="item.S99_CodeId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="project">
            <p>意向专业</p>
            <el-input
              v-model="formLabelAlign.zhuanye"
              placeholder="请输入意向专业"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="button" @click="subBtn">提 交</div>
      </div>
    </div>
    <van-tabs @click="handleItem">
      <van-tab title="首页"></van-tab>
      <van-tab
        v-for="(item, index) in vantabs"
        :title="item.data.MenuName"
        :key="index"
      ></van-tab>
    </van-tabs>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  metaInfo() {
    return {
      title: "招生简章-影像制作学-韩国东国大学中文官网",
      meta: [
        {
          hid: "keywords",
          name: "keywords",
          content:
            "影像制作学硕士招生简章,东国大学硕士招生简章,影像制作学招生简章",
        },
        {
          hid: "description",
          name: "description",
          content: "",
        },
      ],
    };
  },
  name: "zhaoshengjianzhang",
  data() {
    return {
      vantabs: [],
      arrLIst:[],
      formLabelAlign: {
        name: "",
        phone: "",
        xueli: "",
        zhuanye: "",
      },
      //学历
      formxueliList: [],
    };
  },
  activated() {
    this.$emit("handleTKD", "影像制作学");
  },
  mounted() {
    //获取当前学历
    this.getXueliListInfo();
    // this.getList();
    this.getData()
  },
  methods: {
    getData() {
      this.$axios
        .post("/trip/TokenPass/GetPublishMenuContent", {
          WebsiteMenuId: 595,
          index: 1,
          size: 1,
        })
        .then((res) => {
          if (res.data.Code == 200) {
            this.arrLIst = res.data.Data.list;
          } else {
            Notify({ type: "danger", message: res.data.Message });
          }
        });
    },
    // getList() {
    //   this.$axios
    //     .post("/trip/TokenPass/GetMenuTree", {
    //       Source: "238",
    //       IsView: 1,
    //     })
    //     .then((res) => {
    //       this.vantabs = JSON.parse(res.data.Data);
    //       console.log(this.vantabs);
    //     });
    // },
    // name是每一项的下标，直接拿下标映射this.vantab里面的path
    handleItem(name, title) {
      if (title === "东国概况") {
        this.$router.push("/dongguogaikuang.html");
      } else if (title === "首页") {
        this.$router.push("/");
      } else if (title === "影像制作学") {
        this.$router.push("/yingxiangzhizuoxue.html");
      } else if (title === "东国资讯") {
        this.$router.push("/dongguozixun.html");
      } else if (title === "申请报名") {
        this.$router.push("/shenqingbaoming.html");
      } else if (title === "录取查询") {
        this.$router.push("/luquchaxun.html");
      } else {
        this.$router.push("/lianxiwomen.html");
      }
    },
    // 表单提交
    subBtn() {
      let _form = this.formLabelAlign;
      if (!_form.name) {
        this.$message.error("姓名不能为空！");
        return false;
      }
      if (!this.formLabelAlign.phone) {
        this.$message.error("手机号码不能为空！");
        return true;
      } else {
        if (!Number(this.formLabelAlign.phone)) {
          this.$message.error("手机号码只能为数字类型！");
          this.formLabelAlign.phone = "";
          return false;
        }
      }
      if (!_form.xueli) {
        this.$message.error("当前学历不能为空！");
        return false;
      }
      this.$axios
        .post("/trip/InfoSources/WebRegister", {
          C01_Name: _form.name, //姓名
          C01_Tel: _form.phone, //联系方式
          EducationCode: _form.xueli, //当前学历
          C01_Major: _form.zhuanye, //意向专业
          C01_Origin: 239, //来源于那个官网
        })
        .then((res) => {
          if (res.data.Code == 200) {
            this.$message.success("提交成功！");
            this.formLabelAlign.name = "";
            this.formLabelAlign.phone = "";
            this.formLabelAlign.xueli = "";
            this.formLabelAlign.zhuanye = "";
          } else {
            this.$message.error(res.data.Message);
          }
        });
    },
    //获取学历
    getXueliListInfo() {
      this.$axios
        .post("/trip/TokenPass/GetClueCode", {
          S99_GroupCode: "035",
        })
        .then((res) => {
          if (res.data.Code == 200) {
            this.formxueliList = res.data.Data;
          } else {
            Toast(res.data.Message);
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.Oulist {
  width: 100%;

  padding: 0 0.4rem 0 0.4rem;
  /deep/.information {
    // margin: 0 auto;
    width: 100%;
    min-height: 10rem;

    img,
    video {
      max-width: 100%;
    }
  }
}
.yingxiang {
  margin-top: 134px;
  width: 100%;
  padding-top: 0.3rem;
  .header {
    width: 100%;
    height: 400px;
  }
  .main {
    padding-left: 40px;
    padding-right: 40px;
    padding-top: 80px;
    background-color: #fff;
    .title {
      margin: 0 auto;
      width: 279px;
      height: 83px;
      padding-bottom: 50px;
      font-size: 38px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #263340;
      line-height: 42px;
      .oneline {
        position: relative;
        padding-left: 60px;
        .currentImg {
          position: absolute;
          width: 32px;
          height: 29px;
        }
        .left {
          top: 8px;
          left: 0px;
        }
        .right {
          top: 8px;
          right: 0px;
        }
      }
      .twoline {
        margin: 0 auto;
      }
    }
    .liaojie {
      // margin-top: 50px;
      .xuhao {
        padding-right: 33px;
        display: flex;
        align-items: center;
        margin-bottom: 30px;
        height: 90px;
        box-shadow: 0px 2px 10px 0px rgba(80, 80, 80, 0.13);
        img {
          width: 43px;
          height: 43px;
          margin-left: 59px;
          // margin-right: 56px;
        }
        .paiming {
          // height: 31px;
          font-size: 26px;
          font-family: Source Han Sans CN;
          color: #333333;
          line-height: 31px;
          span {
            line-height: 35px;
            font-size: 26px;
            color: #e48035;
          }
        }
      }
      :nth-child(1) {
        img {
          width: 47px;
          height: 43px;
          // margin-left: 54px;
          margin-right: 56px;
        }
      }
      :nth-child(2) {
        img {
          width: 47px;
          height: 43px;
          // margin-left: 54px;
          margin-right: 54px;
        }
      }
      :nth-child(3) {
        img {
          width: 54px;
          height: 40px;
          // margin-left: 50px;
          margin-right: 51px;
        }
      }
      :nth-child(4) {
        img {
          width: 56px;
          height: 39px;
          margin-right: 51px;
        }
      }
      :nth-child(5) {
        img {
          width: 38px;
          height: 44px;
          margin-left: 69px;
          margin-right: 55px;
        }
      }
    }
    .wenzhang {
      margin-top: 39px;
      .content {
        margin-bottom: 40px;
      }
      span {
        display: block;
        font-size: 26px;
        font-family: Source Han Sans CN;
        color: #333333;
        line-height: 40px;
      }
    }
    .gongzuo {
      width: 100%;
      margin-top: 50px;
      background: url("../../assets/images/yingxiang/gongzuo.png") no-repeat;
      background-size: contain;
      height: 226px;
      position: relative;
      .content {
        position: absolute;
        top: 51px;
        left: 38px;
        width: 464px;
        background: #ffffff;
        padding: 29px 26px 30px 27px;
        font-size: 26px;
        font-family: Source Han Sans CN;
        color: #333333;
        line-height: 40px;
      }
    }
    .titletwo {
      margin-top: 80px;
      position: relative;
      span {
        display: block;
        margin: 0 auto;
        width: 470px;
        height: 90px;
        font-size: 38px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #263340;
        text-align: center;
        line-height: 48px;
      }
      .currentImg {
        position: absolute;
        top: 8px;
        width: 22px;
        height: 20px;
      }
      .left {
        left: 194px;
        top: 15px;
      }
      .right {
        right: 194px;
        top: 15px;
      }
    }
    .introduce {
      // margin-top: 50px;
      // padding: 41px 0px 17px 40px;
      // border: 1px solid #d9d9d9;
      .line {
        margin-bottom: 24px;
        height: 26px;
        display: flex;
        .biaoqian {
          width: 74px;
          height: 30px;
          line-height: 32px;
          font-size: 22px;
          padding-left: 15px;
          margin-right: 31px;

          color: #fff;
          background: url("../../assets/images/yingxiang/juxing.png") no-repeat;
          background-size: contain;
        }
        span {
          height: 27px;
          font-size: 27px;
          font-family: Source Han Sans CN;
          color: #333333;
          line-height: 32px;
        }
      }
    }
    .titlethree {
      // margin-top: 80px;
      margin-bottom: 50px;
      padding-top: 60px;
      display: flex;
      justify-content: center;
      align-items: center;
      .currentImg {
        width: 32px;
        height: 29px;
      }
      .left {
        margin-right: 39px;
      }
      .right {
        margin-left: 39px;
      }
      span {
        font-size: 36px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #263340;
      }
    }

    .tese {
      .titlethree {
        // padding-top: 80px;
        margin-bottom: 42px;
        span {
          font-size: 38px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #263340;
        }
      }
      .jiaoxue {
        height: 26px;
        font-size: 26px;
        margin-bottom: 28px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #f7901e;
        line-height: 26px;
      }
      .text {
        font-size: 26px;
        font-family: Source Han Sans CN;
        color: #333333;
        line-height: 38px;
      }
      .tesetu {
        height: 156px;
        margin-top: 28px;
        background: url("../../assets/images/yingxiang/tese.png") no-repeat;
        background-size: contain;
        padding-top: 40px;
        .dianshitai,
        .yule {
          margin-left: 25px;
          height: 28px;
          margin-bottom: 21px;
          display: flex;
          align-items: center;
          div {
            width: 3px;
            height: 18px;
            background: #f7901e;
            margin-right: 20px;
          }
          span {
            height: 28px;
            font-size: 26px;
            font-family: Source Han Sans CN;
            color: #ffffff;
            line-height: 28px;
          }
        }
      }
      .kecheng {
        p {
          height: 26px;
          font-size: 26px;
          margin-top: 49px;
          margin-top: 29px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #f7901e;
          line-height: 26px;
        }
      }
      .kechengmingcheng {
        margin-top: 29px;
        .duizhaobiao {
          height: 50px;
          background: #373b47;
          display: flex;
          .current {
            text-align: center;
            line-height: 50px;
            font-size: 20px;
            font-family: Source Han Sans CN;
            color: #fff;
          }
          .left {
            width: 590px;
            border-right: 1px solid #ccc;
          }
          .right {
            width: 78px;
          }
        }
        ul {
          li {
            height: 40px;
            text-align: center;
            display: flex;
            line-height: 40px;
            font-size: 20px;
            font-family: Source Han Sans CN;
            color: #333;
            .currentborder {
              border-bottom: 1px solid #ccc;
              border-right: 1px solid #ccc;
            }
            .left {
              width: 222px;
              border-left: 1px solid #ccc;
            }
            .center {
              width: 368px;
            }
            .right {
              width: 79px;
            }
          }
        }
      }
    }

    // 学制信息
    .xuezhi {
      background: #f7f7f7;
      height: 1006px;
      margin-top: 60px;
      padding-bottom: 59px;
      margin-bottom: 59px;
      .oneline {
        width: 100%;
        height: 103px;
        padding-right: 65px;
        margin-bottom: 35px;
        display: flex;
        align-items: center;
        .left {
          width: 39px;
          height: 39px;
          margin-left: 75px;
          margin-right: 55px;
          img {
            width: 100%;
          }
        }
        .right {
          .tit {
            height: 20px;
            font-size: 28px;
            font-family: Source Han Sans CN;
            margin-bottom: 19px;
            color: #333333;
            line-height: 27px;
          }
          span {
            font-size: 26px;
            font-family: Source Han Sans CN;
            color: #666666;
            line-height: 36px;
          }
        }
      }
      :nth-child(2) {
        .left {
          display: block;
          width: 45px;
          height: 45px;
          margin-left: 73px;
          margin-right: 48px;
        }
      }
      :nth-child(3) {
        .left {
          width: 43px;
          height: 43px;
          margin-left: 66px;
          margin-right: 46px;
        }
      }
      :nth-child(4) {
        .left {
          width: 45px;
          height: 45px;
          margin-left: 70px;
          margin-right: 50px;
        }
      }
      :nth-child(5) {
        .left {
          width: 45px;
          height: 45px;
          margin-left: 65px;
          margin-right: 48px;
        }
      }
      :nth-child(6) {
        .left {
          width: 45px;
          height: 45px;
          margin-left: 71px;
          margin-right: 54px;
        }
      }
      :nth-child(7) {
        .left {
          display: block;
          width: 70px;
          height: 70px;
          margin-left: 65px;
          margin-right: 50px;
        }
        margin-bottom: 0px;
      }
    }
  }
  .pingtu {
    width: 100%;
    padding: 0px 33px 69px 31px;
    .oneline {
      display: flex;
      margin-bottom: 39px;
      .currentdiv {
        width: 333px;
        height: 320px;
        margin-right: 20px;
        padding-top: 105px;
        span {
          display: block;
          height: 30px;
          font-size: 28px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          text-align: center;
          line-height: 30px;
          margin-bottom: 28px;
        }
        p {
          height: 105px;
          font-size: 26px;
          font-family: Source Han Sans CN;
          color: #333333;
          text-align: center;
          line-height: 37px;
        }
      }
      .sdiv {
        background: url("../../assets/images/yingxiang/s.png") no-repeat;
        background-size: cover;
        span {
          color: #f7901e;
        }
      }
      .pdiv {
        background: url("../../assets/images/yingxiang/p.png") no-repeat;
        background-size: cover;
        margin-right: 0px;
        span {
          color: #85c0df;
        }
      }
    }
    .twoline {
      display: flex;
      position: relative;
      .zimu {
        position: absolute;
        left: 152px;
        top: 17px;
        width: 28px;
        height: 42px;
        text-align: center;
        line-height: 42px;
        font-size: 56px;
        font-family: Source Han Sans CN;
        color: #6e485e;
      }
      .currentdiv {
        width: 333px;
        height: 320px;
        margin-right: 20px;
        padding-top: 105px;
        span {
          display: block;
          height: 30px;
          font-size: 28px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          text-align: center;
          line-height: 30px;
          margin-bottom: 28px;
        }
        p {
          height: 105px;
          font-size: 26px;
          font-family: Source Han Sans CN;
          color: #333333;
          text-align: center;
          line-height: 37px;
        }
      }
      .kongdiv {
        background: url("../../assets/images/yingxiang/kong.png") no-repeat;
        background-size: cover;
        span {
          color: #6e485e;
        }
      }
      .ddiv {
        background: url("../../assets/images/yingxiang/d.png") no-repeat;
        background-size: cover;
        margin-right: 0px;
        span {
          color: #77a094;
        }
      }
    }
  }
  .maintwo {
    padding-left: 40px;
    padding-right: 40px;
    .titlethree {
      display: flex;
      margin-bottom: 50px;
      justify-content: center;
      align-items: center;
      .currentImg {
        width: 32px;
        height: 29px;
      }
      .left {
        margin-right: 20px;
      }
      .right {
        margin-left: 20px;
      }
      span {
        font-size: 36px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #fff;
      }
    }

    .fuwu {
      padding-top: 80px;
      .titlethree {
        span {
          color: #263340;
        }
      }
      ul {
        li {
          display: inline-block;
          width: 210px;
          height: 266px;
          margin-right: 20px;
          margin-bottom: 30px;
          padding-top: 20px;
          background: #f3f3f3;
          border-bottom: 4px solid #fb7d27;
          .icon {
            width: 112px;
            height: 112px;
            margin: 0 auto;
            img {
              width: 100%;
            }
          }
          p {
            height: 59px;
            font-size: 26px;
            margin-top: 14px;
            font-family: Source Han Sans CN;
            color: #333333;
            text-align: center;
            line-height: 35px;
          }
          span {
            display: block;
            height: 17px;
            font-size: 20px;
            margin-top: 24px;

            color: #ffa161;
            text-align: center;
            line-height: 17px;
          }
        }
        :nth-child(3) {
          margin-right: 0px;
        }
        :nth-child(6) {
          margin-right: 0px;
        }
      }
    }
    .biye {
      .titlethree {
        // margin-top: 50px;
        span {
          color: #263340;
        }
        .left {
          margin-right: 38px;
        }
        .right {
          margin-left: 38px;
        }
      }
      .cells {
        width: 100%;
        height: 405px;
        background: #f8f8f8;
        .cell {
          display: flex;
          height: 86px;
          border-bottom: 1px dashed #dcdcdc;
          align-items: center;
          padding-left: 40px;
          .xuhao {
            width: 26px;
            height: 26px;
            margin-right: 31px;
            background: #f7901e;
            text-align: center;
            font-size: 20px;
            font-family: Source Han Sans CN;
            line-height: 26px;
            color: #fff;
          }
          .text {
            font-size: 26px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #333333;
            line-height: 39px;
          }
        }
        :nth-child(1) {
          height: 134px;
          position: relative;
          .xuhao {
            position: absolute;
            top: 35px;
            left: 40px;
          }
          .text {
            margin-left: 56px;
          }
        }
        :nth-child(4) {
          height: 96px;
          border-bottom: none;
        }
      }
    }
  }
  .fazhan {
    margin-top: 49px;
    padding-top: 52px;
    width: 100%;
    height: 915px;
    background: url("../../assets/images/yingxiang/fazhan.png");
    background-size: contain;
    .titlefour {
      display: flex;
      justify-content: center;
      align-items: center;
      .currentImg {
        width: 32px;
        height: 29px;
      }
      .left {
        margin-right: 38px;
      }
      .right {
        margin-left: 38px;
      }
      span {
        font-size: 36px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #263340;
      }
    }
    .zong {
      margin-top: 49px;
      padding-left: 40px;
      padding-right: 40px;
      .oneline {
        display: flex;
        .cell {
          width: 330px;
          height: 250px;
          background: #ffffff;
          margin-right: 9px;
          margin-bottom: 30px;
          .biaodiv {
            margin: 0 auto;
            height: 46px;
            font-size: 26px;
            font-family: Source Han Sans CN;
            color: #ffffff;
            background: #f89a49;
            text-align: center;
            line-height: 46px;
            margin-bottom: 30px;
          }
          .ps {
            padding-left: 40px;
            font-size: 24px;
            font-family: Source Han Sans CN;
            color: #333333;
            line-height: 40px;
          }
        }
        :nth-child(1) {
          .biaodiv {
            width: 169px;
          }
        }
        :nth-child(2) {
          margin-right: 0px;
          .biaodiv {
            width: 266px;
          }
        }
      }
      .twoline {
        :nth-child(1) {
          .biaodiv {
            width: 273px;
          }
        }
        :nth-child(2) {
          .biaodiv {
            width: 187px;
          }
          .ps {
            p {
              padding-left: 6px;
            }
          }
        }
      }
      .bottom {
        background-color: #fff;
        margin-top: 10px;
        height: 130px;
        .biaotidiv {
          width: 206px;
          height: 46px;
          background: #f89a49;
          margin: 0 auto;
          font-size: 26px;
          font-family: Source Han Sans CN;
          color: #ffffff;
          text-align: center;
          line-height: 46px;
          margin-bottom: 29px;
        }
        span {
          display: block;
          height: 26px;
          font-size: 26px;
          font-family: Source Han Sans CN;
          color: #333333;
          text-align: center;
          line-height: 26px;
        }
      }
    }
  }
  .mainthree {
    padding-left: 40px;
    padding-right: 40px;
    .titlefive {
      display: flex;
      margin-top: 80px;
      margin-bottom: 48px;
      justify-content: center;
      align-items: center;
      .currentImg {
        width: 32px;
        height: 29px;
      }
      .left {
        margin-right: 38px;
      }
      .right {
        margin-left: 38px;
      }
      span {
        font-size: 36px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #263340;
      }
    }
    .liucheng {
      width: 100%;
      height: 540px;
      padding-top: 19px;
      background: url("../../assets/images/yingxiang/liucheng.png") no-repeat;
      background-size: contain;
      p {
        height: 21px;
        font-size: 22px;
        font-family: Source Han Sans CN;
        color: #333333;
        text-align: center;
        line-height: 21px;
      }
      :nth-child(2) {
        margin-top: 62px;
      }
      :nth-child(3) {
        margin-top: 56px;
      }
      :nth-child(4) {
        margin-top: 58px;
      }
      :nth-child(5) {
        margin-top: 58px;
      }
      :nth-child(6) {
        margin-top: 59px;
      }
      :nth-child(7) {
        margin-top: 59px;
      }
    }
    .zhusu {
      .sushetext {
        display: block;
        height: 26px;
        font-size: 26px;
        font-family: Source Han Sans CN;
        color: #333333;
        margin-bottom: 29px;
        line-height: 26px;
      }
      .tupian {
        img {
          width: 100%;
        }
      }
      .sushe {
        height: 184px;
        margin-bottom: 50px;
      }
      .xueshengsushe {
        height: 301px;
        margin-bottom: 30px;
      }
      .tongji {
        height: 173px;
      }
    }
    .weizhi {
      display: block;
      height: 265px;
      font-size: 26px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      margin-bottom: 51px;
      line-height: 40px;
    }
    .ditu {
      display: flex;
      align-items: center;
      img {
        width: 266px;
        height: 152px;
        margin-right: 29px;
      }
      .miaoshu {
        height: 106px;
        font-size: 26px;
        font-family: Source Han Sans CN;
        color: #333333;
        line-height: 35px;
      }
    }
  }
  .biaodan {
    width: 100%;
    height: 725px;
    margin-top: 80px;
    background: url("../../assets/images/yingxiang/biaodanbeijing.png")
      no-repeat;
    background-size: contain;
    padding-top: 56px;
    span {
      display: block;
      height: 36px;
      font-size: 36px;
      margin-bottom: 20px;

      font-weight: bold;
      color: #ffffff;
      text-align: center;
      line-height: 36px;
    }
    p {
      height: 26px;
      font-size: 26px;

      font-weight: 400;
      color: #ffffff;
      text-align: center;
      line-height: 26px;
    }
    //表单
    .biaodanbox {
      width: 100%;
      margin: 0 auto;
      padding: 0 91px 0 73px;
      /deep/.el-form {
        margin: 0 auto;
        position: relative;
        margin-top: 39px;
        .el-form-item {
          margin-bottom: 20px;
          p {
            display: flex;
            position: absolute;
            z-index: 1;
            top: 26px;
            left: 30px;
            font-size: 24px;
            padding-left: 10px;
            font-family: Source Han Sans CN;
            opacity: 0.8;
            color: #222222;
            .icon {
              position: absolute;
              top: -5px;
              left: -3px;
              font-size: 24px;
              color: #ff0000;
            }
          }
          .el-select,
          .el-input {
            width: 100%;
          }
          .el-select-dropdown__item {
            span {
              font-size: 26px;
            }
          }
          .el-input__suffix {
            right: 35px;
            .el-input__suffix-inner {
              .el-input__icon {
                font-size: 26px;
              }
            }
          }
          .el-form-item__content {
            .el-input__inner {
              width: 100%;
              height: 77px;
              padding-left: 157px;
              font-size: 20px;
              line-height: 77px;
              background: #ffffff;
              border: 2px solid #d9d9d9;
              border-radius: 4px;
              letter-spacing: 2px;
            }
          }
        }
        .project {
          margin-top: 20px;
          p {
            left: 41px;
          }
        }
        .margbottom0 {
          margin-bottom: 0px;
        }
      }
      .button {
        height: 75px;
        background: #f7901e;
        border-radius: 5px;
        text-align: center;
        line-height: 75px;
        margin: 0 auto;
        font-size: 28px;
        box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.13);
        font-family: Source Han Sans CN;
        color: #ffffff;
        margin-top: 36px;
      }
    }
  }
  /deep/ .van-tabs {
    background-color: #f48729;
    .van-tabs__wrap--scrollable {
      margin-right: 26px;
      background-color: #f48729;
      .van-tabs__nav {
        .van-tab {
          padding: 0;
          margin: 0;
          margin-left: 27px;
          .van-tab__text {
            height: 74px;
            color: #fff;
            font-size: 26px;
            font-family: Source Han Sans CN;
            margin-left: 1px;
            font-weight: 500;
            line-height: 74px;
          }
          .van-tabs__line {
            bottom: 10px;
          }
        }
        .van-tabs__line {
          bottom: -10px;
        }
      }
      .van-tabs__nav--complete {
        background: #f48729;
        padding: 0;
      }
    }
  }
}
</style>
